import { useEffect, useRef, useState } from "react";

interface Props {
  secondiRimasti: number | undefined;
  onExpired: () => void;
}

function fmt(secs: number) {
  const m = Math.floor(secs / 60).toString().padStart(2, "0");
  const s = Math.floor(secs % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
}

export function ServerTimer({ secondiRimasti, onExpired }: Props) {
  const [now, setNow] = useState(() => Date.now());
  const expiredRef = useRef(false);
  const deadlineRef = useRef<number | null>(null);

  // Aggiorna la deadline ogni volta che il server ci dà un nuovo valore.
  useEffect(() => {
    if (secondiRimasti === undefined) {
      deadlineRef.current = null;
      return;
    }
    deadlineRef.current = Date.now() + secondiRimasti * 1000;
    expiredRef.current = false;
    setNow(Date.now());
  }, [secondiRimasti]);

  useEffect(() => {
    if (deadlineRef.current === null) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [secondiRimasti]);

  if (deadlineRef.current === null) return null;

  const remaining = Math.max(0, Math.floor((deadlineRef.current - now) / 1000));

  if (remaining === 0 && !expiredRef.current) {
    expiredRef.current = true;
    onExpired();
  }

  const isCritical = remaining < 60;
  return (
    <div
      className={`
        inline-flex items-center gap-2 px-3 py-1.5 rounded-lg font-mono
        ${isCritical ? "bg-red-500/20 text-red-300" : "bg-bg text-secondary border border-border"}
      `}
    >
      <span className="text-xs uppercase tracking-wider">⏱</span>
      <span className="tabular-nums">{fmt(remaining)}</span>
    </div>
  );
}
